import { takeEvery } from 'redux-saga/effects';

import { ActionTypes } from '../constants';
import { updateLayeredRelationsSilentlyRequest } from './updateLayeredRelationsSilentlyRequest';

export default [
  takeEvery(ActionTypes.UPDATE_LAYERED_RELATIONS_SILENTLY, updateLayeredRelationsSilentlyRequest),
];
